export * from '@primeuix/themes/lara/paginator';
export { default } from '@primeuix/themes/lara/paginator';
